// Countdown module: initializes [id^="Countdown-"] containers
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="Countdown-"]').forEach((container) => {
    const sectionId = container.id.replace("Countdown-", "");
    const expiredEl = document.getElementById("CountdownExpired-" + sectionId);
    const deadlineAttr = container.getAttribute("data-deadline");
    if (!deadlineAttr) return;
    const deadlineDate = new Date(deadlineAttr);
    if (isNaN(deadlineDate.getTime())) {
      if (expiredEl) {
        container.classList.add("hidden");
        expiredEl.classList.remove("hidden");
      }
      return;
    }
    const deadline = deadlineDate.getTime();

    function pad(n) {
      return String(n).padStart(2, "0");
    }
    const units = ["days", "hours", "minutes", "seconds"];
    const unitEls = {};
    units.forEach((u) => {
      const wrapper = container.querySelector('[data-unit="' + u + '"]');
      if (wrapper) unitEls[u] = wrapper.querySelector("[data-value]");
    });

    function compute() {
      const now = Date.now();
      const diff = deadline - now;
      if (diff <= 0) return null;
      const days = Math.floor(diff / 864e5);
      const hours = Math.floor((diff % 864e5) / 36e5);
      const minutes = Math.floor((diff % 36e5) / 6e4);
      const seconds = Math.floor((diff % 6e4) / 1e3);
      return { days, hours, minutes, seconds };
    }

    function updateDisplay(map) {
      units.forEach((unit) => {
        const el = unitEls[unit];
        if (!el) return;
        const val = pad(map[unit]);
        if (el.textContent !== val) {
          el.style.transform = "scale(1.08)";
          el.textContent = val;
          el.setAttribute("datetime", String(map[unit]));
          setTimeout(() => {
            el.style.transform = "";
          }, 150);
        }
      });
    }

    let current = compute();
    if (!current) {
      if (expiredEl) {
        container.classList.add("hidden");
        expiredEl.classList.remove("hidden");
      }
      return;
    }
    updateDisplay(current);
    const intervalId = setInterval(() => {
      const next = compute();
      if (!next) {
        clearInterval(intervalId);
        if (expiredEl) {
          container.classList.add("hidden");
          expiredEl.classList.remove("hidden");
        }
        return;
      }
      updateDisplay(next);
    }, 1000);
  });
});
